import React, { FC } from 'react';

const IconHome: FC = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" {...props}>
      <polygon
        fillRule="evenodd"
        points="4.103 16 16 3.83 27.94 16 24.033 16 24.033 27.708 18.681 27.708 18.681 20.105 13.448 20.105 13.448 27.708 8.108 27.708 8.108 16"
        transform="translate(-4 -3)"
      />
    </svg>
  );
};

export default IconHome;
